import { useEffect, useState } from 'react';

const API = '/api/taskcenter';

function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) };
}

const C = { bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56', danger: '#A32D2D' };
const card = { background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '0.9rem 1rem', marginBottom: 10 };
const btn = { padding: '7px 14px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' };
const btnGhost = { ...btn, background: '#fff', color: C.text, border: `0.5px solid ${C.border}` };
const inp = { width: '100%', padding: '8px 10px', fontSize: 13, border: `0.5px solid ${C.border}`, borderRadius: 8, boxSizing: 'border-box', marginBottom: 8 };
const lbl = { fontSize: 12, color: C.muted, display: 'block', marginBottom: 3 };
const TYPE_EMOJI = { twitter: '🐦', telegram: '✈️', discord: '💬', youtube: '▶️', visit: '🔗', penflow: '🖋️', other: '⭐' };

function AirdropsHelpModal({ onClose }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: '1.2rem 1.3rem', maxWidth: 480, maxHeight: '80vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <p style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>🎁 How Xpert Airdrops works</p>
          <button onClick={onClose} style={{ ...btnGhost, padding: '4px 10px' }}>✕</button>
        </div>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>🙋 Participants (free)</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>Kisi bhi active campaign ko join karein — bilkul free. Tasks complete karein (follow, join, visit) — har task par entries milti hain. Apna referral link doston se share karein: har naya join extra entries deta hai. Jitni zyada entries, jeetne ka utna zyada chance. Campaign end par winners ka Pi prize seedha unke Task wallet mein jata hai, jahan se withdrawal ho sakti hai.</p>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>📢 Projects (campaign creators)</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>Apne Pi project ki growth ke liye campaign banayen — reward pool, winners ki tadaad, aur tasks set karein. Winner selection do tarah ki: Random draw (entries jitni zyada, chance utna zyada) ya Top entries. Reward pool + listing fee ka escrow Pi se pehle jama hota hai — isliye participants ko reward ki guarantee hoti hai. Campaign end par "Draw winners" dabayen, prizes automatic distribute ho jate hain.</p>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>🛡️ Fair play</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>Har user har task sirf ek baar kar sakta hai. Escrow ki wajah se koi project reward de kar bhaag nahi sakta. Winners list campaign page par sab ko nazar aati hai.</p>
      </div>
    </div>
  );
}

function CampaignDetail({ id, onBack }) {
  const [c, setC] = useState(null);
  const [msg, setMsg] = useState('');
  const [pendingTask, setPendingTask] = useState(null);
  const [countdown, setCountdown] = useState(0);

  const load = () => fetch(`${API}/campaigns/${id}/`, { headers: authHeaders() }).then((r) => r.json()).then(setC);
  useEffect(() => { load(); }, [id]); // eslint-disable-line

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const join = async () => {
    const ref = new URLSearchParams(window.location.search).get('ref') || '';
    const d = await fetch(`${API}/campaigns/${id}/join/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ ref }) }).then((r) => r.json());
    if (d.success) { setMsg('✅ Joined! Tasks complete kar ke entries barhayen'); load(); } else setMsg(d.error || 'Failed');
  };

  const doTask = (t) => {
    if (t.link) window.open(t.link, '_blank');
    setPendingTask(t.id);
    setCountdown(10);
  };

  const claimTask = async (t) => {
    const d = await fetch(`${API}/campaign-tasks/${t.id}/complete/`, { method: 'POST', headers: authHeaders() }).then((r) => r.json());
    if (d.success) { setMsg(`✅ +${t.entries_reward} entries (total: ${d.entries})`); setPendingTask(null); load(); }
    else setMsg(d.error || 'Failed');
  };

  const copyRef = () => {
    const url = `${window.location.origin}/airdrops?campaign=${id}&ref=${c.my_referral_code}`;
    navigator.clipboard && navigator.clipboard.writeText(url);
    setMsg('✅ Referral link copied: ' + url);
  };

  if (!c) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  const joined = c.my_entries !== null && c.my_entries !== undefined;
  return (
    <div>
      <button style={{ ...btnGhost, marginBottom: 10 }} onClick={onBack}>← All airdrops</button>
      <div style={card}>
        <p style={{ fontSize: 17, fontWeight: 700, margin: '0 0 4px' }}>🎁 {c.title}</p>
        <p style={{ fontSize: 13, color: C.muted, margin: '0 0 6px' }}>{c.description}</p>
        <p style={{ fontSize: 13, margin: 0 }}><b style={{ color: C.primary }}>{c.reward_pool} π pool</b> · {c.winners_count} winners ({c.selection_method === 'top' ? 'top entries' : 'random draw'}) · ends {c.ends_at} · {c.participants} joined</p>
        {msg && <p style={{ fontSize: 13, color: C.primary, margin: '6px 0 0' }}>{msg}</p>}
        {!joined && c.status === 'active' && <button style={{ ...btn, marginTop: 8 }} onClick={join}>Join campaign</button>}
        {joined && (
          <div style={{ marginTop: 8 }}>
            <p style={{ fontSize: 13, margin: '0 0 6px' }}>Your entries: <b style={{ color: C.primary }}>{c.my_entries}</b> · Referral = +{c.referral_entries} entries</p>
            <button style={btnGhost} onClick={copyRef}>📋 Copy referral link</button>
          </div>
        )}
      </div>
      {joined && c.tasks.map((t) => {
        const done = (c.my_done || []).includes(t.id);
        return (
          <div key={t.id} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
              <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>{TYPE_EMOJI[t.task_type] || '⭐'} {t.title}</p>
              <span style={{ fontSize: 12, color: C.primary, whiteSpace: 'nowrap' }}>+{t.entries_reward}</span>
            </div>
            <div style={{ marginTop: 6 }}>
              {done ? <span style={{ fontSize: 12, color: C.primary }}>✅ Done</span>
                : pendingTask === t.id
                  ? countdown > 0
                    ? <span style={{ fontSize: 12, color: C.muted }}>Verifying… {countdown}s</span>
                    : <button style={btn} onClick={() => claimTask(t)}>Claim entries</button>
                  : <button style={btnGhost} onClick={() => doTask(t)}>Do task ↗</button>}
            </div>
          </div>
        );
      })}
      {c.leaderboard && c.leaderboard.length > 0 && (
        <div style={card}>
          <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 6px' }}>🏆 Leaderboard</p>
          {c.leaderboard.map((e, i) => (
            <p key={i} style={{ fontSize: 12, color: C.muted, margin: '2px 0' }}>{i + 1}. @{e.user} — {e.entries} entries</p>
          ))}
        </div>
      )}
      {c.winners && c.winners.length > 0 && (
        <div style={{ ...card, borderColor: C.primary }}>
          <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 6px' }}>🎉 Winners</p>
          {c.winners.map((w, i) => (
            <p key={i} style={{ fontSize: 12, margin: '2px 0' }}>@{w.user} — <b style={{ color: C.primary }}>{w.prize} π</b></p>
          ))}
        </div>
      )}
    </div>
  );
}

function CreateCampaign({ onDone }) {
  const [form, setForm] = useState({ title: '', description: '', reward_pool: '10', winners_count: '5', selection_method: 'random', duration_days: '7', referral_entries: '3' });
  const [tasks, setTasks] = useState([{ title: '', task_type: 'twitter', link: '', entries_reward: 1 }]);
  const [quote, setQuote] = useState(null);
  const [msg, setMsg] = useState('');
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const updTask = (i, k) => (e) => { const t = tasks.slice(); t[i] = { ...t[i], [k]: k === 'entries_reward' ? parseInt(e.target.value || 1, 10) : e.target.value }; setTasks(t); };

  const create = async () => {
    setMsg('');
    const d = await fetch(`${API}/campaigns/create/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ ...form, tasks }) }).then((r) => r.json());
    if (!d.success) { setMsg(d.error || 'Failed'); return; }
    if (d.status === 'active') { setMsg('✅ Campaign live (super admin)'); onDone(); return; }
    setQuote(d);
  };

  const pay = async () => {
    if (!window.Pi) { setMsg('Pi Browser mein kholein payment ke liye'); return; }
    if (window.xpertPayConfirm && !(await window.xpertPayConfirm({ amount: quote.total_due, memo: 'XpertAirdrops campaign — reward pool escrow' }))) return;
    await window.Pi.authenticate(['username', 'payments'], () => {});
    window.Pi.createPayment(
      { amount: quote.total_due, memo: `XpertAirdrops — campaign #${quote.campaign_id}`, metadata: { type: 'campaign_escrow', campaign_id: quote.campaign_id } },
      {
        onReadyForServerApproval: (paymentId) => {
          fetch(`${API}/escrow-approve/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ payment_id: paymentId }) });
        },
        onReadyForServerCompletion: (paymentId, txid) => {
          fetch(`${API}/campaign-escrow-complete/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ payment_id: paymentId, tx_id: txid, campaign_id: quote.campaign_id }) })
            .then((r) => r.json())
            .then((d2) => { if (d2.success) { setMsg('✅ Campaign live!'); onDone(); } else setMsg(d2.error || 'Activation failed'); });
        },
        onCancel: () => setMsg('Payment cancelled'),
        onError: () => setMsg('Payment error'),
      }
    );
  };

  return (
    <div style={card}>
      {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
      <label style={lbl}>Title</label>
      <input style={inp} value={form.title} onChange={upd('title')} placeholder="Launch airdrop — 100 π pool" />
      <label style={lbl}>Description</label>
      <input style={inp} value={form.description} onChange={upd('description')} />
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Reward pool (π)</label><input style={inp} type="number" value={form.reward_pool} onChange={upd('reward_pool')} /></div>
        <div style={{ flex: 1 }}><label style={lbl}>Winners</label><input style={inp} type="number" value={form.winners_count} onChange={upd('winners_count')} /></div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Selection</label>
          <select style={inp} value={form.selection_method} onChange={upd('selection_method')}>
            <option value="random">Random draw (weighted)</option>
            <option value="top">Top entries win</option>
          </select></div>
        <div style={{ flex: 1 }}><label style={lbl}>Duration (days)</label><input style={inp} type="number" value={form.duration_days} onChange={upd('duration_days')} /></div>
        <div style={{ flex: 1 }}><label style={lbl}>Referral entries</label><input style={inp} type="number" value={form.referral_entries} onChange={upd('referral_entries')} /></div>
      </div>
      <p style={{ fontSize: 13, fontWeight: 600, margin: '4px 0 6px' }}>Tasks</p>
      {tasks.map((t, i) => (
        <div key={i} style={{ border: `0.5px dashed ${C.border}`, borderRadius: 8, padding: '8px', marginBottom: 8 }}>
          <input style={inp} value={t.title} onChange={updTask(i, 'title')} placeholder="Follow us on X" />
          <div style={{ display: 'flex', gap: 8 }}>
            <select style={{ ...inp, flex: 1 }} value={t.task_type} onChange={updTask(i, 'task_type')}>
              <option value="twitter">Twitter/X</option><option value="telegram">Telegram</option>
              <option value="discord">Discord</option><option value="youtube">YouTube</option>
              <option value="penflow">PenFlow</option><option value="visit">Visit link</option>
              <option value="other">Other</option>
            </select>
            <input style={{ ...inp, flex: 1 }} type="number" value={t.entries_reward} onChange={updTask(i, 'entries_reward')} placeholder="entries" />
          </div>
          <input style={{ ...inp, marginBottom: 0 }} value={t.link} onChange={updTask(i, 'link')} placeholder="https://..." />
        </div>
      ))}
      <button style={{ ...btnGhost, marginBottom: 10 }} onClick={() => setTasks([...tasks, { title: '', task_type: 'visit', link: '', entries_reward: 1 }])}>➕ Add task</button>
      <div>
        {!quote
          ? <button style={btn} onClick={create}>Get quote</button>
          : (
            <div style={{ background: '#F7F5F0', borderRadius: 8, padding: '0.6rem 0.8rem' }}>
              <p style={{ fontSize: 13, margin: '0 0 6px' }}>Pool {form.reward_pool} π + listing {quote.listing_fee} π + commission {quote.commission} π = <b>{quote.total_due} π</b></p>
              <button style={btn} onClick={pay}>Pay with Pi</button>
            </div>
          )}
      </div>
    </div>
  );
}

function MyCampaigns() {
  const [cs, setCs] = useState(null);
  const [msg, setMsg] = useState('');
  const load = () => fetch(`${API}/campaigns/mine/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setCs(d.campaigns || []));
  useEffect(() => { load(); }, []);
  const draw = async (id) => {
    if (!window.confirm('Draw winners now? Ye action wapas nahi hota.')) return;
    const d = await fetch(`${API}/campaigns/${id}/draw/`, { method: 'POST', headers: authHeaders() }).then((r) => r.json());
    if (d.success) { setMsg('🎉 Winners: ' + d.winners.map((w) => '@' + w.user).join(', ')); load(); }
    else setMsg(d.error || 'Failed');
  };
  if (cs === null) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  if (cs.length === 0) return <p style={{ fontSize: 13, color: C.muted }}>No campaigns yet.</p>;
  return (
    <div>
      {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
      {cs.map((c) => (
        <div key={c.id} style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>{c.title}</p>
            <span style={{ fontSize: 12, color: C.muted }}>{c.status}</span>
          </div>
          <p style={{ fontSize: 12, color: C.muted, margin: '4px 0 6px' }}>{c.reward_pool} π · {c.participants} joined · ends {c.ends_at}</p>
          {(c.status === 'active' || c.status === 'ended') && <button style={btn} onClick={() => draw(c.id)}>🎲 Draw winners & pay</button>}
        </div>
      ))}
    </div>
  );
}

export default function Airdrops({ user }) {
  const params = new URLSearchParams(window.location.search);
  const [tab, setTab] = useState('browse');
  const [showHelp, setShowHelp] = useState(false);
  const [openId, setOpenId] = useState(params.get('campaign') ? parseInt(params.get('campaign'), 10) : null);
  const [cs, setCs] = useState(null);
  const load = () => fetch(`${API}/campaigns/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setCs(d.campaigns || []));
  useEffect(() => { load(); }, []);
  if (!localStorage.getItem('token')) return <p style={{ padding: '2rem', fontSize: 14 }}>Please login first.</p>;
  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      {showHelp && <AirdropsHelpModal onClose={() => setShowHelp(false)} />}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>🎁 Xpert Airdrops</h1>
        <button onClick={() => setShowHelp(true)} style={{ ...btnGhost, borderRadius: 20, flexShrink: 0 }}>❓ How it works</button>
      </div>
      <p style={{ fontSize: 13, color: C.muted, margin: '0 0 1rem' }}>Join campaigns, complete tasks, earn entries — win Pi from reward pools.</p>
      <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
        <button style={{ ...btnGhost, background: tab === 'browse' ? C.primary : '#fff', color: tab === 'browse' ? '#fff' : C.text }} onClick={() => { setTab('browse'); setOpenId(null); }}>🔍 Browse</button>
        <button style={{ ...btnGhost, background: tab === 'create' ? C.primary : '#fff', color: tab === 'create' ? '#fff' : C.text }} onClick={() => setTab('create')}>➕ Create</button>
        <button style={{ ...btnGhost, background: tab === 'mine' ? C.primary : '#fff', color: tab === 'mine' ? '#fff' : C.text }} onClick={() => setTab('mine')}>📢 My campaigns</button>
      </div>
      {tab === 'browse' && (openId
        ? <CampaignDetail id={openId} onBack={() => { setOpenId(null); load(); }} />
        : cs === null ? <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>
          : cs.length === 0 ? <p style={{ fontSize: 13, color: C.muted }}>No active campaigns.</p>
            : cs.map((c) => (
              <div key={c.id} style={{ ...card, cursor: 'pointer' }} onClick={() => setOpenId(c.id)}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>🎁 {c.title}</p>
                  <b style={{ fontSize: 14, color: C.primary }}>{c.reward_pool} π</b>
                </div>
                <p style={{ fontSize: 12, color: C.muted, margin: '4px 0 0' }}>{c.winners_count} winners · {c.participants} joined · ends {c.ends_at} · by @{c.creator}</p>
              </div>
            )))}
      {tab === 'create' && <CreateCampaign onDone={() => { setTab('mine'); }} />}
      {tab === 'mine' && <MyCampaigns />}
    </div>
  );
}
